import type { DialogsContainerProps } from '@confluence/dialogs/entry-points/DialogsStateContainer.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { PagePublishAutomationDiscoveryDialogProps } from '../src/PagePublishAutomationDiscoveryDialog.tsx';
export { PagePublishAutomationDiscoveryDialog } from '../src/PagePublishAutomationDiscoveryDialog.tsx';
export const LazyPagePublishAutomationDiscoveryDialog: LoadableType<
	PagePublishAutomationDiscoveryDialogProps & DialogsContainerProps
> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PagePublishAutomationDiscoveryDialog" */ '../src/PagePublishAutomationDiscoveryDialog.tsx'
			)
		).PagePublishAutomationDiscoveryDialog,
});
